import {IResource} from "./i-resource";

export abstract class AbstractResource implements IResource{
  id: string;
  resourceURl: string;

  constructor(id: string, resourceURl: string) {
    this.id = id;
    this.resourceURl = resourceURl;
  }

    abstract getName(): string;

    getResourceId(): string {
        return this.id;
    }
    getResourceUrl(): string {
        return this.resourceURl;
    }
}
